/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Deeply match a route tree given a name
 */

import invariant from 'tiny-invariant'

const matchName = (names, options) => {
  if (typeof options === 'string') {
    options = { name: options }
  }
  const name = options.name

  if (name && names.includes(name)) {
    return options
  }

  return null
}

const matchRoute = (names, branch) => (route) => {
  const match = matchName(names, route)
  if (match) {
    branch.push(route)
  }

  return !!match
}

export const matchRoutesByName = (routes, names, { branch = [] } = {}) => {
  invariant(Array.isArray(routes), 'routes must be an array')
  invariant(Array.isArray(names), 'names must be an array')
  routes.forEach(matchRoute(names, branch))
  return branch
}
